import React from "react";
import { useAppContext } from "../context/ContextProvider";
import Logueo from "./Logueo";

const Alumno = () => {
    const { usuarioGlobal } = useAppContext();
    return usuarioGlobal ? (
        <section class="body-font text-white">
            <div class="container px-5 py-24 mx-auto">
                <div class="flex flex-col text-center w-full mb-20 h-screen">
                    <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
                        Alumnos
                    </h1>
                    <p class="lg:w-2/3 mx-auto leading-relaxed text-base">
                        Listado de alumnos
                    </p>
                </div>
            </div>
        </section>
    ) : (
        <Logueo />
    );
};

export default Alumno;
